module.exports = __webpack_public_path__ + "static/img/adv1.a00d50f4.jpg";